import { useTranslation } from 'react-i18next'
import { AlertTriangle } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  automationName: string
  onConfirm: () => void
  loading?: boolean
}

export function DeleteConfirmationDialog({
  open,
  onOpenChange,
  automationName,
  onConfirm,
  loading = false
}: DeleteConfirmationDialogProps) {
  const { t } = useTranslation()

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            {t('actions.confirm_delete_title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('actions.confirm_delete_message', { name: automationName })}
            <br />
            <br />
            {t('actions.confirm_delete_description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>
            {t('common.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={loading}
            className="bg-destructive hover:bg-destructive"
          >
            {loading ? t('functions.loading') : t('actions.delete_automation')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
